import React, { Component } from "react";
import "./style.less";
import MyDiscount from "./MyDiscount";
import MyInvite from "./MyInvite";
import inviteFocusPng from "./SpreadImage/inviteFocus.png";
import discountFocus from "./SpreadImage/discountFocus.png";
import noDiscount from "./SpreadImage/noFocus.png";
import noInvite from "./SpreadImage/ino.png";
import { getFavorable } from "@/api/favorableMessage";

const PROMO = "PROMO_CODE";
const DISCOUNT = "DISCOUNT_CODE";
const INVITE = "MyInvite";
const IS_INVITE = "invite";
const IS_DISCOUNT = "discount";

class MySpread extends Component {
  constructor() {
    super();
    this.state = {
      choose: "MyInvite",
      isThis: "invite",
      data: [],
    }
  }

  componentDidMount() {
    getFavorable().then(data => {
        this.setState({
            data,
        })
    });
  }
 
   get dueDate() {
     return this.state.data && 
              this.state.data.length > 0 &&
                  new Date(parseInt(this.state.data[0].expireTime) * 1000).toLocaleDateString();
   }

   get inviteId() {
     const inviteData = this.state.data.filter(item => item.promoType === PROMO);
     return inviteData.length > 0 ? inviteData[0] : {};
   }

   get disountIds() {
      return this.state.data.filter(item => item.promoType === DISCOUNT);
   }

  handleInvite = () => {
    this.setState({ choose: "MyInvite", isThis: "invite" });
  };
  handleDiscount = () => {
    this.setState({ choose: "MyDiscount", isThis: "discount" });
  };

  render() {
    return (
      <div className="body">
        <div className="select">
          {this.state.isThis === IS_INVITE ? (
            <div className="selectBtn yesSelect" onClick={this.handleInvite}>
              <img className="spreadImg" alt="invite" src={inviteFocusPng} />
              <span>我的邀请码</span>
            </div>
          ) : (
            <div className="selectBtn noSelect" onClick={this.handleInvite}>
              <img className="spreadImg" alt="invite" src={noInvite} />
              <span>我的邀请码</span>
            </div>
          )}

          {this.state.isThis === IS_DISCOUNT ? (
            <div className="selectBtn yesSelect" onClick={this.handleDiscount}>
              <img className="spreadImg" alt="discount" src={discountFocus} />
              <span>我的折扣码</span>
            </div>
          ) : (
            <div className="selectBtn noSelect" onClick={this.handleDiscount}>
              <img className="spreadImg" alt="discount" src={noDiscount} />
              <span>我的折扣码</span>
            </div>
          )}
        </div>
        <div className="show">
          {
            this.state.choose === INVITE ?
              <MyInvite dueDate = {this.dueDate} myId = {this.inviteId.promoCode}/> :
              <MyDiscount discountList={this.disountIds} />
          }
        </div>
      </div>
    );
  }
}

export default MySpread;
